import React, { useContext, useEffect } from "react";

import { EventStatusLegend } from "@features/offer/shared/event/EventStatusLegend";
import BetBuilderPicksEventPopup from "@features/quick-play/mobile/bet-builder-picks/BetBuilderPicksEventPopup";
import BetBuilderPicksEventSlider from "@features/quick-play/mobile/bet-builder-picks/BetBuilderPicksEventSlider";
import BettingTipsPopup from "@features/quick-play/mobile/betting-tips/BettingTipsPopup";
import BettingTipsEventList from "@features/quick-play/mobile/betting-tips/components/BettingTipsEventList";
import { useOfferOptionsContext } from "@state/hooks/offer/useOfferOptionsContext";
import EventViewStore from "@state/stores/offer/event/EventViewStore.mobile";
import { THEME_SETTINGS } from "@theme-settings";
import { observer } from "mobx-react";

import {
	BettingTypeGroups,
	EmptyBettingTypes,
	GroupedBettingTypesHeader,
} from "./markets";
import { BetBoosterSubHeader } from "./markets/BetBoosterSubHeader";

export const EventMarkets = observer(function EventMarkets({
	store,
}: {
	store: EventViewStore;
}) {
	const isBettingTipsFeatureEnabled =
		THEME_SETTINGS.features.quickPlayOptions?.includes("betting-tips");

	const isBetBuilderFeatureEnabled =
		THEME_SETTINGS.features.quickPlayOptions?.includes("bet-builder-picks");
	const offerOptionsContext = useOfferOptionsContext();
	if (store.bettingTypeGroups.length === 0) {
		return <EmptyBettingTypes />;
	}

	const isBetBuilderAvailable =
		(store?.betBoosterEventPicks?.betBuilderPicksStore?.betBuilderPresetIds
			?.length ?? 0) > 0;

	const isBettingTipsAvailable =
		store.bettingTipsStore.bettingTips?.length > 0;

	if (
		store.activeSubGroup == "bet-builder" &&
		!isBetBuilderAvailable &&
		isBettingTipsAvailable
	) {
		store.setActiveSubGroup("betting-tips");
	}

	if (
		store.activeSubGroup == "betting-tips" &&
		!isBettingTipsAvailable &&
		isBetBuilderAvailable
	) {
		store.setActiveSubGroup("bet-builder");
	}

	return (
		<>
			<BetBuilderPicksEventPopup />

			<BettingTipsPopup bettingTipsStore={store.bettingTipsStore} />
			<div className="event__section event__section--quick">
				{store.displayBettingGroup === "all" &&
					isBetBuilderFeatureEnabled &&
					isBetBuilderAvailable &&
					isBettingTipsFeatureEnabled &&
					isBettingTipsAvailable && <BetBoosterSubHeader />}

				{isBetBuilderFeatureEnabled &&
					(store.displayBettingGroup === "bet-builder" ||
						(store.displayBettingGroup === "all" &&
							store.activeSubGroup === "bet-builder")) && (
						<BetBuilderPicksEventSlider />
					)}

				{store.displayBettingGroup === "all" &&
					store.activeSubGroup === "betting-tips" && (
						<BettingTipsEventList />
					)}
			</div>

			<div className="event__section event__section--offer">
				<GroupedBettingTypesHeader />
				{offerOptionsContext.isOfferHistory && <EventStatusLegend />}

				<div className="event__offer">
					<BettingTypeGroups />
				</div>
			</div>
		</>
	);
});
